import get from 'lodash.get';

const getHtaccessSupported = (rootState) =>
  get(rootState, 'user.partnerData.properties.htaccessSupported', false);

export default getHtaccessSupported;
